import React from "react";
import {
    Tooltip,
} from "@material-ui/core";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import WorkIcon from "@material-ui/icons/Work";
import CallIcon from "@material-ui/icons/Call";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";

const ActivityTypeIcon = ({ type, title }) => {
    return (
        <Tooltip title={title}>
            <div style={{ display: "flex" }}>
                {type === "M" && <PlayCircleFilledIcon style={{ height: 20 }} />}
                {type === "E" && <QuestionAnswerIcon style={{ height: 20 }} />}
                {type === "S" && <CallIcon style={{ height: 20 }} />}
                {type === "P" && <WorkIcon style={{ height: 20 }} />}
                {type === "L" && <MenuBookIcon style={{ height: 20 }} />}
            </div>
        </Tooltip>
    )
}

export default ActivityTypeIcon;